export default __webpack_public_path__ + "static/media/Resources.283bf949.svg";